import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ReactNode } from 'react';

export const ERROR_MODAL_FEATURE_KEY = 'modal';

export interface ModalState {
  isVisible: boolean;
  title?: string;
  content?: ReactNode;
}

const initialState: ModalState = {
  isVisible: false,
  title: undefined,
  content: undefined,
};

const modalSlice = createSlice({
  name: ERROR_MODAL_FEATURE_KEY,
  initialState,
  reducers: {
    showModal: (
      state,
      action: PayloadAction<{ title?: string; message?: string; buttonText?: string; content?: ReactNode }>
    ) => {
      state.isVisible = true;
      state.title = action.payload.title;
      state.content = action.payload.content;
    },
    hideModal: (state) => {
      state.isVisible = false;
      setTimeout(() => {
        // state.title = undefined;
        // state.content = undefined;
      }, 300);
    },
  },
});

export const { showModal, hideModal } = modalSlice.actions;
export default modalSlice.reducer;
